import { Link } from 'react-router-dom';
import Arrow from '../../../components/ui/Arrow';
import { brand } from '../../../content/site';
import { localizedPath, useLocale, useMessages } from '../../../i18n/locale';
import FadeInOnScroll from '../../../components/effects/FadeInOnScroll';
import BlurText from '../../../components/effects/BlurText';

export default function DocsSection() {
  const locale = useLocale();
  const copy = useMessages().home.docs;
  return (
    <section id="docs" className="docs-section">
      <div className="container docs-layout">
        <FadeInOnScroll className="docs-copy">
          <h2>
            <BlurText text={copy.title[0]} />
            <br />
            <BlurText text={copy.title[1]} className="muted-heading" delay={140} />
          </h2>
          <p>{copy.description}</p>
          <Link className="text-link" to={localizedPath(locale, '/docs')}>
            {copy.explore} <Arrow />
          </Link>
        </FadeInOnScroll>
        <FadeInOnScroll className="docs-preview" aria-label={copy.previewLabel} delay={100}>
          <div className="docs-preview__side">
            <strong>
              <span>◇</span> {brand.name} Docs
            </strong>
            <small>{copy.sidebarLabels[0]}</small>
            <span className="docs-nav-active">◈　{copy.preview[0]}</span>
            <span>　　{copy.preview[1]}</span>
            <span>　　{copy.preview[2]}</span>
            <small>{copy.sidebarLabels[1]}</small>
            <span>　　{copy.preview[3]}</span>
            <span>　　{copy.preview[4]}</span>
            <span>　　{copy.sidebarLabels[2]}</span>
          </div>
          <div className="docs-preview__page">
            <div className="docs-breadcrumb">
              {copy.breadcrumb[0]} <span>/</span> {copy.breadcrumb[1]} <span>/</span>{' '}
              {copy.breadcrumb[2]}
            </div>
            <div className="docs-preview__tag">{copy.tag}</div>
            <h3>{copy.preview[5]}</h3>
            <p>{copy.preview[6]}</p>
            <div className="docs-rule" />
            <div className="docs-block docs-block--one" />
            <div className="docs-block docs-block--two" />
            <div className="docs-callout">
              <span>✳</span> {copy.callout}
            </div>
          </div>
        </FadeInOnScroll>
      </div>
    </section>
  );
}
